import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { ColumnSettings } from '../../../../shared/model/column-settings.interface';
import { GridSettings } from '../../../../shared/model/grid-settings.interface';
import { AuthService } from '../../../security/service/auth.service';
import {
  PartsListResultsColumnsModel,
  PartsListResultsColumnsModelNoCaps
} from '../../model/parts-list-results-columns-model';
import { PartsService } from '../../service/parts.service';

@Component({
  selector: 'app-parts-list-results',
  templateUrl:
    'console/app-js/modules/parts/components/parts-list-results/parts-list-results.component.html'
})
export class PartsListResultsComponent implements OnChanges {
  @ViewChild('partsGrid', { static: true }) partsGrid: any;
  @Input('data') data: any[];
  @Input('loading') loading: boolean;
  @Input('noSearchResults') noSearchResults: boolean;
  @Output('pageChange') pageChange = new EventEmitter<any>();
  @Output('rowChecked') rowChecked = new EventEmitter<any>();
  private checkedItems = [];
  public selectableSettings: SelectableSettings = {
    enabled: true,
    checkboxOnly: true,
    mode: 'single'
  };
  public noRecordsSettings = {
    message: '',
    styleClass: 'no-records-wrapper'
  };
  public gridSettings: GridSettings = {
    state: {
      skip: 0,
      take: 5,
      filter: {
        logic: 'and',
        filters: []
      }
    },
    columnsConfig: this.authService.isViewerOrManager()
      ? PartsListResultsColumnsModelNoCaps
      : PartsListResultsColumnsModel,
    realColWidths: []
  };

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected authService: AuthService,
    protected partsService: PartsService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    const sessionGridSettings: GridSettings = this.partsService.getStatePersistingInputs();
    if (sessionGridSettings) {
      this.gridSettings = this.mapGridSettings(sessionGridSettings);
    }
    if (changes.data) {
      this.checkedItems = [];
    }
    this.loadParts();
  }

  private loadParts() {
    if (this.noSearchResults) {
      this.noRecordsSettings.message = 'No Results Found';
      this.noRecordsSettings.styleClass = null;
    }
  }

  infinityScroll(): void {
    this.pageChange.emit();
  }

  public appliedColumnOrder(e: Array<ColumnSettings>) {
    this.gridSettings.columnsConfig = e;
    this.gridSettings.realColWidths = [];
    this.saveGrid();
  }

  private saveGrid(): void {
    const gridConfig: GridSettings = {
      columnsConfig: this.gridSettings.columnsConfig,
      state: this.gridSettings.state,
      realColWidths: this.gridSettings.realColWidths
    };
    this.partsService.setStatePersistingInputs(gridConfig);
  }

  /**
   *
   * @param gridSettings custom GridSettings object by using custom logic.
   */
  public mapGridSettings(gridSettings: GridSettings): GridSettings {
    const state = gridSettings.state;
    return {
      state,
      columnsConfig: gridSettings.columnsConfig,
      realColWidths:
        gridSettings.realColWidths && gridSettings.realColWidths.length > 0
          ? gridSettings.realColWidths
          : []
    };
  }

  public getInactiveRow = (row: any): any => {
    return row.dataItem.isActive === 'Inactive' ? 'inactive-row' : false;
  };

  public onCellClick({ dataItem, columnIndex }) {
    if (columnIndex !== 0) {
      this.router.navigate([`${dataItem.id}`], { relativeTo: this.route });
    }
  }

  public selectedRowChange(event) {
    event.selectedRows.map(item => {
      this.checkedItems.push(item.dataItem);
    });
    // if item was deselected, remove it from checkedItems
    this.checkedItems = this.checkedItems.filter(checkedItem => {
      return !event.deselectedRows.some(deselectedItem => {
        return checkedItem.id === deselectedItem.dataItem.id;
      });
    });
    this.rowChecked.emit(this.checkedItems);
  }
}
